import IntegrationActionCreator from 'action_creators/integration';

import './index.scss';
import PropTypes from 'prop-types';
import React from 'react';
import ReactPlayer from 'react-player';
import createReactClass from 'create-react-class';
import _ from 'underscore';
import $ from 'jquery';
import StoreInterestMixin from 'lib/flux/store/interest_mixin';
import { isActionKey } from 'ui_system/utilities/KeyboardHelpers';
import Slideshow from './slideshow';

export const TourPageGallery = createReactClass({
  displayName: 'TourPage-Gallery',

  mixins: [StoreInterestMixin],

  propTypes: {
    photos: PropTypes.array.isRequired,
    media_setting: PropTypes.object,
  },

  getDefaultProps() {
    return {
      photos: [],
      media_setting: {},
    };
  },

  getStoreInterests() {
    return {
      parentViewport: 'integration.parentViewport',
    };
  },

  getInitialState() {
    return {
      slideshowVisible: false,
      parentViewport: null,
      isPlayerVisible: true,
      isPlayerPause: false,
      isBrowserFocused: true,
      currentVideoTime: 0,
      videoTimeOnCarouselOpen: 0,
    };
  },

  componentDidUpdate(prevProps, prevState) {
    if (this.state.slideshowVisible !== prevState.slideshowVisible) {
      this.setState({ isPlayerVisible: !this.state.slideshowVisible });
    }
  },

  componentDidMount() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    document.addEventListener('scroll', this.handleScrollChange);
  },

  componentWillUnmount() {
    document.removeEventListener(
      'visibilitychange',
      this.handleVisibilityChange
    );
    document.removeEventListener('scroll', this.handleScrollChange);
  },

  handleVisibilityChange() {
    if (document.hidden) {
      // Page is hidden, pause the video
      this.setState({ isBrowserFocused: false });
    } else {
      // Page is visible again, resume the video if needed
      this.setState({ isBrowserFocused: true });
    }
  },

  handleScrollChange() {
    const galleryRect = this.galleryRef.getBoundingClientRect();
    const isComponentVisible =
      galleryRect.top < window.innerHeight && galleryRect.bottom >= 0;

    this.setState({ isBrowserFocused: isComponentVisible });
  },

  coverPhotoClicked() {
    const { currentVideoTime } = this.state;
    IntegrationActionCreator.queryParentViewport();
    this.setState({
      slideshowVisible: true,
      isPlayerVisible: false,
      videoTimeOnCarouselOpen: currentVideoTime,
    });
  },

  closeGallery() {
    this.coverPhotoBtnRef.focus();
    this.setState(
      (prevState) => ({
        isPlayerVisible: true,
        slideshowVisible: false,
      }),
      () => {
        if (this._isMediaLinkPresent()) {
          this.player?.seekTo(this.state.currentVideoTime);
        }
      }
    );
  },

  _renderGalleryPlaceholder() {
    return (
      <div className="cover-photo-wrap placeholder">
        <i className="icon af-mountains" />
      </div>
    );
  },

  _isMediaLinkPresent() {
    const { media_setting: mediaSetting } = this.props;
    return (
      mediaSetting &&
      mediaSetting.hasOwnProperty('media_link') &&
      mediaSetting['media_link'] !== null
    );
  },

  _renderChevrons() {
    if (this.props.photos.length > 1 || this._isMediaLinkPresent()) {
      return (
        <div>
          <i
            role="button"
            className="icon af-angle-left-light"
            aria-label="Previous image"
          />
          <i
            role="button"
            className="icon af-angle-right-light"
            aria-label="Next image"
          />
        </div>
      );
    }
  },

  _handleVideoProgress(progress) {
    this.setState({ currentVideoTime: progress.playedSeconds });
  },

  _renderGallery() {
    const { photos, media_setting } = this.props;
    const {
      parentViewport,
      slideshowVisible,
      isPlayerVisible,
      isPlayerPause,
      isBrowserFocused,
      videoTimeOnCarouselOpen,
    } = this.state;
    // let style, slideshowProps;
    const style = {
      backgroundImage: `url('${photos[0]}')`,
    };

    const slideshowProps = {
      parentViewport: parentViewport && parentViewport.toJS(),
      isVisible: slideshowVisible,
      photos: photos,
      mediaSetting: media_setting,
      onClose: this.closeGallery,
      currentVideoTime: videoTimeOnCarouselOpen,
    };

    const multiplePhotos = photos?.length > 1 || this._isMediaLinkPresent();

    const renderVideoOrCover = () => {
      const isMediaPresent = this._isMediaLinkPresent();
      if (isMediaPresent && media_setting?.display_at_start) {
        return (
          <ReactPlayer
            url={media_setting?.media_link}
            playing={isPlayerVisible && !isPlayerPause && isBrowserFocused}
            controls
            muted
            ref={(player) => (this.player = player)}
            height="100%"
            width="100%"
            playsinline
            onPause={() => {
              if (isPlayerVisible && isBrowserFocused) {
                this.setState({ isPlayerPause: true });
              }
            }}
            onPlay={() => this.setState({ isPlayerPause: false })}
            onProgress={this._handleVideoProgress}
          />
        );
      } else {
        return (
          <div
            className="cover-photo"
            aria-label="Cover photo"
            style={style}
            ref="coverPhoto"
          />
        );
      }
    };

    return (
      <>
        <button
          type="button"
          aria-label="cover photo"
          ref={(elmnt) => {
            this.coverPhotoBtnRef = elmnt;
          }}
          className={`inner ${
            multiplePhotos ? 'cover-photo-wrap' : 'cover-photo-wrap-single'
          }`}
          // Only show photo carousel on click if there are multiple photos
          onClick={() => (multiplePhotos ? this.coverPhotoClicked() : null)}
          onKeyDown={(e) =>
            multiplePhotos && isActionKey(e.key)
              ? this.coverPhotoClicked()
              : null
          }
        >
          {renderVideoOrCover()}
          {this._renderChevrons()}
        </button>

        <Slideshow
          {...slideshowProps}
          handleVideoProgress={this._handleVideoProgress}
        />
      </>
    );
  },

  render() {
    return (
      <div
        ref={(galleryRef) => (this.galleryRef = galleryRef)}
        className="TourPage-Gallery"
      >
        {this._renderGallery()}
      </div>
    );
  },
});
